<template>
  <div></div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'DayRedirect',
  async created () {
    let queryDay = this.$route.query.day
    let day = moment(queryDay).format('DD')
    let month = moment(queryDay).format('MM')
    let year = moment(queryDay).format('YYYY')
    let params = {
      year, month, day, panel: this.$route.query.panel
    }
    for (let key in this.$route.query) {
      if (key !== 'panel' && key !== 'vue' && key !== 'day') {
        params[key] = this.$route.query[key]
      }
    }
    this.$router.replace({ name: this.$route.query.vue, params: params })
  }
}
</script>
